// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/background/authbg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AuthMainWrapper{
    width: 100%;
    display: flex;
    align-items: center;
    height: 100vh !important;
    justify-content: center;
    overflow-y: auto;
    box-sizing: border-box;
}

.logo{
    max-width: 200px;
}

.AuthMainWrapper .garbageImg{
    height: 100%;
}

.loginInputWrapper{
    border-radius: 10px !important;
    box-shadow: rgba(0, 0, 0, 0.20) 0px 2px 8px;
    padding: 30px;
    height: fit-content;
}

.loginInputWrapper form{
  max-width: 400px;
  min-width: 300px;
  margin: auto;
  height: fit-content;
}

.AuthMainWrapper .garbageImg img{
    height: 100%;
width: 100%;
object-fit: contain;
object-position: left;
}

.AuthContainer {
  position: relative; 
  display: flex;
  gap: 20px;
  padding: 30px 30px;
  align-items: center;
}

.AuthContainer::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center -80px;
  background-size: contain;
  opacity: 0.6;
  z-index: -1;
}
  
  .loginBtn{
    background: linear-gradient(
      90deg,
      rgba(40, 143, 67, 1) 0%,
      rgba(118, 185, 95, 1) 100%
   );
  }

  .loginBtn:hover{
    background: linear-gradient(
      0deg,
      rgba(40, 143, 67, 1) 0%,
      rgba(118, 185, 95, 1) 100%
   );
  }

@media (max-width:1100px){
  .loginInputWrapper{
    padding: 20px;
  }
.loginInputWrapper{
  width: 100% !important;
}
  .AuthMainWrapper .garbageImg {
    width: 70% !important;
  }
  .AuthMainWrapper{
    height: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/commanComponents/CommonLayout/AuthLayout.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;IACI,YAAY;AAChB,WAAW;AACX,mBAAmB;AACnB,qBAAqB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yDAA2D;EAC3D,4BAA4B;EAC5B,iCAAiC;EACjC,wBAAwB;EACxB,YAAY;EACZ,WAAW;AACb;;EAEE;IACE;;;;IAIA;EACF;;EAEA;IACE;;;;IAIA;EACF;;AAEF;EACE;IACE,aAAa;EACf;AACF;EACE,sBAAsB;AACxB;EACE;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".AuthMainWrapper{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    height: 100vh !important;\n    justify-content: center;\n    overflow-y: auto;\n    box-sizing: border-box;\n}\n\n.logo{\n    max-width: 200px;\n}\n\n.AuthMainWrapper .garbageImg{\n    height: 100%;\n}\n\n.loginInputWrapper{\n    border-radius: 10px !important;\n    box-shadow: rgba(0, 0, 0, 0.20) 0px 2px 8px;\n    padding: 30px;\n    height: fit-content;\n}\n\n.loginInputWrapper form{\n  max-width: 400px;\n  min-width: 300px;\n  margin: auto;\n  height: fit-content;\n}\n\n.AuthMainWrapper .garbageImg img{\n    height: 100%;\nwidth: 100%;\nobject-fit: contain;\nobject-position: left;\n}\n\n.AuthContainer {\n  position: relative; \n  display: flex;\n  gap: 20px;\n  padding: 30px 30px;\n  align-items: center;\n}\n\n.AuthContainer::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: url('../../assets/background/authbg.svg');\n  background-repeat: no-repeat;\n  background-position: center -80px;\n  background-size: contain;\n  opacity: 0.6;\n  z-index: -1;\n}\n  \n  .loginBtn{\n    background: linear-gradient(\n      90deg,\n      rgba(40, 143, 67, 1) 0%,\n      rgba(118, 185, 95, 1) 100%\n   );\n  }\n\n  .loginBtn:hover{\n    background: linear-gradient(\n      0deg,\n      rgba(40, 143, 67, 1) 0%,\n      rgba(118, 185, 95, 1) 100%\n   );\n  }\n\n@media (max-width:1100px){\n  .loginInputWrapper{\n    padding: 20px;\n  }\n.loginInputWrapper{\n  width: 100% !important;\n}\n  .AuthMainWrapper .garbageImg {\n    width: 70% !important;\n  }\n  .AuthMainWrapper{\n    height: 100% !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
